import { render, staticRenderFns } from "./Fatura.vue?vue&type=template&id=d5642004"
import script from "./Fatura.vue?vue&type=script&lang=js"
export * from "./Fatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports